(function () {
  let scrubs = [];
  let lastActive = null;

  function collectScrubs() {
    scrubs = [];
    document.querySelectorAll('.pc-scrub[data-scrub]').forEach(function (el) {
      const data = el.getAttribute('data-images');
      if (!data) return;

      let imgs;
      try {
        imgs = JSON.parse(data);
      } catch (e) {
        console.warn('[pc-scrub] Failed to parse data-images', e, data);
        return;
      }

      if (!imgs || imgs.length < 2) return;

      const imgEl = el.querySelector('.pc-scrub__img');
      if (!imgEl) return;

      const allowDesktop = el.dataset.scrubDesktop === 'true';
      const allowMobile = el.dataset.scrubMobile === 'true';

      if (!allowDesktop && !allowMobile) return;

      scrubs.push({
        el: el,
        imgEl: imgEl,
        imgs: imgs,
        allowDesktop: allowDesktop,
        allowMobile: allowMobile,
        lastIndex: 0
      });

      // Start on first image
      imgEl.src = imgs[0];
      imgEl.srcset = '';
    });

    lastActive = null;
  }

  function setImageForScrub(scrub, index) {
    index = Math.max(0, Math.min(scrub.imgs.length - 1, index));
    if (index === scrub.lastIndex) return;
    scrub.lastIndex = index;
    scrub.imgEl.src = scrub.imgs[index];
    scrub.imgEl.srcset = '';
  }

  function resetScrub(scrub) {
    setImageForScrub(scrub, 0);
  }

  function setActive(scrub) {
    if (scrub === lastActive) return;

    if (lastActive) {
      resetScrub(lastActive);
    }

    lastActive = scrub;
  }

  function handlePointer(x, y, isDesktop) {
    if (!scrubs.length) return;

    let active = null;

    for (let i = 0; i < scrubs.length; i++) {
      const s = scrubs[i];

      if (isDesktop && !s.allowDesktop) continue;
      if (!isDesktop && !s.allowMobile) continue;

      const rect = s.el.getBoundingClientRect();
      if (
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
      ) {
        active = s;

        // Map x position to image index
        const relX = (x - rect.left) / (rect.width || 1);
        const idx = Math.floor(relX * s.imgs.length);
        setImageForScrub(s, idx);
        break;
      }
    }

    setActive(active);
  }

  function setupGlobalListeners() {
    // Desktop mouse move
    document.addEventListener('mousemove', function (e) {
      handlePointer(e.clientX, e.clientY, true);
    });

    // Mobile touch move
    document.addEventListener(
      'touchmove',
      function (e) {
        if (!e.touches || !e.touches[0]) return;
        const t = e.touches[0];
        handlePointer(t.clientX, t.clientY, false);
      },
      { passive: true }
    );

    // On touch end, reset whichever card was last active
    document.addEventListener(
      'touchend',
      function () {
        if (lastActive) resetScrub(lastActive);
        lastActive = null;
      },
      { passive: true }
    );
    document.addEventListener(
      'touchcancel',
      function () {
        if (lastActive) resetScrub(lastActive);
        lastActive = null;
      },
      { passive: true }
    );

    // On mouse leaving window, reset
    window.addEventListener('mouseleave', function () {
      if (lastActive) resetScrub(lastActive);
      lastActive = null;
    });
  }

  function init() {
    collectScrubs();
    setupGlobalListeners();
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section reloads (theme editor, etc.)
  document.addEventListener('shopify:section:load', collectScrubs);
  document.addEventListener('shopify:block:select', collectScrubs);
  document.addEventListener('shopify:block:deselect', collectScrubs);

  // Back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) collectScrubs();
  });

  // Watch for dynamically added cards
  const mo = new MutationObserver((mList) => {
    for (const m of mList) {
      if (!m.addedNodes) continue;

      let needsRecollect = false;

      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (
          (node.matches && node.matches('.pc-scrub[data-scrub]')) ||
          (node.querySelectorAll &&
            node.querySelectorAll('.pc-scrub[data-scrub]').length)
        ) {
          needsRecollect = true;
        }
      });

      if (needsRecollect) collectScrubs();
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
